export default __webpack_public_path__ + "static/media/noel.25c070e4.jpg";